import { FC } from 'react'
import { Text, VStack } from '@chakra-ui/react'

interface LeaderBoardProps {
  scores: number[]
}

export const LeaderBoard: FC<LeaderBoardProps> = ({ scores }) => {
  return (
    <VStack align="stretch" px={8} spacing={6} minH="256px">
      <Text textAlign="center" color="#F0980A" fontSize="32px">
        High scores
      </Text>
      <VStack spacing={0} fontSize={32}>
        {scores.length < 1 && <Text fontSize="24px">No high scores</Text>}
        {scores.map((score, i) => (
          <Text key={i}>{score}</Text>
        ))}
      </VStack>
    </VStack>
  )
}
